import React, { useState, useEffect } from "react";
import { Box, Typography, CircularProgress, Button } from "@mui/material";
import MaterialTable from "../../components/Table/MaterialTable"; // Adjust this import path as needed
import * as XLSX from "xlsx";

const Contacts = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Simulate API call
    const fetchData = async () => {
      setLoading(true);
      try {
        // Replace with real API call
        const data = [
          {
            contact_id: "C001",
            name: "John Doe",
            role: "Manager",
            email: "john@example.com",
            phone: "+91-1234567890",
            company: "ABC Corp"
          },
          {
            contact_id: "C002",
            name: "Jane Smith",
            role: "Sales",
            email: "jane@example.com",
            phone: "+91-9876543210",
            company: "XYZ Ltd"
          }
        ];
        setContacts(data);
      } catch (error) {
        console.error("Error fetching contacts:", error);
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  const handleExportToExcel = () => {
    const formattedData = contacts.map((item) => ({
      "Contact ID": item.contact_id,
      "Name": item.name,
      "Role": item.role,
      "Email": item.email,
      "Phone": item.phone,
      "Company": item.company
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Contacts");

    XLSX.writeFile(workbook, "Contacts.xlsx");
  };

  const columns = [
    { title: "Contact ID", field: "contact_id" },
    { title: "Name", field: "name" },
    { title: "Role", field: "role" },
    { title: "Email", field: "email" },
    { title: "Phone", field: "phone" },
    { title: "Company", field: "company" }
  ];

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        Contact List
      </Typography>

      <Box mb={2}>
        <Button variant="contained" color="primary" onClick={handleExportToExcel}>
          Export to Excel
        </Button>
      </Box>

      {loading ? (
        <CircularProgress />
      ) : (
        <MaterialTable
          title="Contacts"
          columns={columns}
          data={contacts}
          options={{
            search: true,
            paging: true,
            exportButton: false
          }}
        />
      )}
    </Box>
  );
};

export default Contacts;
